export const themes = {
    "id": "default",
    "title": "Olá, Bruno",
    "imagem": "exemple.png",
    "color": [
        {
            "title": "Data",
            "--bg-color": "#0E162D",
            "--bg-cards-color": "#1E293B",
            "--shadow-color": "#314462",
            "--spotlight-text-color": "#38BDF8",
            "--deafult-text-color": "#FFFFFF",
        }
    ]
}


export const linksArray = [
    {
        title: "Dev",
        links: [
            {
                title: "Github",
                url: "https://github.com/bruno-bento",
                shortcut: "gh",
            },
            {
                title: "StackOverflow",
                url: "https://stackoverflow.com/",
                shortcut: "so",
            },
            {
                title: "Figma",
                url: "https://www.figma.com/files/",
                shortcut: "",
            },
            {
                title: "CodePen",
                url: "https://codepen.io/",
                shortcut: "cp",
            },
            {
                title: "Coolors",
                url: "https://coolors.co/",
                shortcut: "cl",
            }
        ],
    },
    {
        title: "Reddit",
        links: [
            {
                title: "Unixporn",
                url: "https://www.reddit.com/r/unixporn/",
                shortcut: "",
            },
            {
                title: "ProgrammerHumor",
                url: "https://www.reddit.com/r/ProgrammerHumor/",
                shortcut: "",
            },
            {
                title: "Brasil",
                url: "https://www.reddit.com/r/brasil/",
                shortcut: "",
            },
        ]
    },
    {
        title: "Social",
        links: [
            {
                title: "WhatsApp",
                url: "https://web.whatsapp.com",
                shortcut: "",
            },
            {
                title: "Spotify",
                url: "https://open.spotify.com",
                shortcut: "",
            },
            {
                title: "Gmail",
                url: "https://mail.google.com/mail/u/1/#inbox",
                shortcut: "",
            },
        ]
    }
]
